import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import { CssFlex } from "styles/helpers/layout";
import type { ElearningThemeInterface } from "themes/elearningInterface.theme";

interface Props {
  theme: ElearningThemeInterface;
}

export const StyledBreadcrumbs = styled(CssFlex)<Props>`
  column-gap: 0.5rem;
  color: ${({ theme }: Props) => theme.palette.neutral._700};
`;

interface StyledBreadcrumbLinkProps extends Props {
  $active?: boolean;
}

export const StyledBreadcrumbLink = styled(Link)<StyledBreadcrumbLinkProps>`
  text-decoration: none;
  color: ${({ $active, theme }: StyledBreadcrumbLinkProps) => ($active ? theme.palette.primary.brand : theme.palette.neutral._400)};
`;
